module.exports = __webpack_public_path__ + "img/title-bg.24c44f82.png";